module.exports = __webpack_public_path__ + "img/contentImgHover7.1b402d2.webp";